import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-4 sm:p-6 lg:p-8 relative" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = { class: "card p-8 sm:p-10 shadow-lg border border-gray-200/80 dark:border-gray-700" }
const _hoisted_4 = { class: "flex justify-center mb-6" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_7 = { class: "rounded-2xl bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 p-6 text-center" }
const _hoisted_8 = { class: "flex justify-center mb-3" }
const _hoisted_9 = { class: "h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-900/50 flex items-center justify-center" }
const _hoisted_10 = {
  key: 1,
  class: "mb-5 rounded-xl bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-800 p-4"
}
const _hoisted_11 = { class: "flex items-center space-x-2.5" }
const _hoisted_12 = { class: "text-xs text-emerald-700 dark:text-emerald-300" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "flex items-center justify-between pt-1" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "pt-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-current",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = { class: "mt-6 pt-5 border-t border-gray-100 dark:border-gray-700 text-center" }
const _hoisted_22 = { class: "text-xs text-gray-500 dark:text-gray-400" }

import { ref, computed } from 'vue'
import logoImage from '@/assets/company-logo.png'
import { useTitle } from '@/composables/ui/useTitle'
import { useLogin } from '@/composables/auth/useLogin'
import { useAuthStore } from '@/stores/auth'
import { useThemeStore } from '@/stores/theme'
import { Sun, Moon, CheckCircle, Eye, EyeOff } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

useTitle('Login')

const authStore = useAuthStore()
const { email, password, loading, handleLogin, handleLogout } = useLogin()
const successMessage = ref('')
const rememberMe = ref(false)
const showPassword = ref(false)

const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)
const toggleTheme = () => {
  themeStore.toggleTheme()
}

// Detect if running inside an iframe (e.g., embedded on WordPress)
const isInIframe = computed(() => window.self !== window.top)

// Show "already logged in" state when authenticated inside an iframe
const isAlreadyLoggedIn = computed(() => authStore.isAuthenticated && isInIframe.value)

function openPortalInNewTab() {
  const baseUrl = process.env.VUE_APP_BASE_URL || ''
  const targetPath = authStore.isAdmin ? '/staff' : '/staff/training-materials'
  const portalUrl = window.location.origin + baseUrl + targetPath
  window.open(portalUrl, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "fixed top-4 right-4 z-50 flex items-center justify-center w-10 h-10 rounded-full bg-white dark:bg-gray-800 shadow-md border border-gray-200/80 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:shadow-lg transition-all duration-200 focus:outline-none",
      onClick: toggleTheme,
      title: "Toggle light/dark theme"
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(isDarkMode.value ? _unref(Sun) : _unref(Moon)), { class: "h-5 w-5" }))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(logoImage),
            alt: "Jeducare Services",
            class: "h-24 sm:h-28 w-auto object-contain",
            style: _normalizeStyle(isDarkMode.value ? 'filter: drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff);' : '')
          }, null, 12, _hoisted_5)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-center mb-6" }, [
          _createElementVNode("h1", { class: "text-2xl font-bold text-gray-900 dark:text-white" }, " Welcome! "),
          _createElementVNode("p", { class: "mt-1.5 text-sm text-gray-500 dark:text-gray-400" }, " Sign in to your account to continue ")
        ], -1)),
        (isAlreadyLoggedIn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(CheckCircle), { class: "h-6 w-6 text-secondary dark:text-secondary-dark-text" })
                  ])
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-base font-semibold text-gray-900 dark:text-white mb-1" }, " You're already signed in ", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mb-5" }, " The portal is ready for you. Open it in a new tab to continue. ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: openPortalInNewTab,
                  class: "btn btn-primary w-full py-2.5 font-bold"
                }, " Open Portal "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleLogout) && _unref(handleLogout)(...args))),
                  class: "mt-3 w-full text-xs text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                }, " Sign out ")
              ])
            ]))
          : _createCommentVNode("", true),
        (successMessage.value && !isAlreadyLoggedIn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(CheckCircle), { class: "h-5 w-5 text-emerald-600 dark:text-emerald-400 flex-shrink-0" }),
                _createElementVNode("p", _hoisted_12, _toDisplayString(successMessage.value), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!isAlreadyLoggedIn.value)
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              class: "space-y-4",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(handleLogin)(rememberMe.value)), ["prevent"]))
            }, [
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  for: "email-address",
                  class: "label"
                }, "Email address", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email-address",
                  name: "email",
                  type: "email",
                  autocomplete: "email",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                  class: "input",
                  placeholder: "name@jeducareservices.com"
                }, null, 512), [
                  [_vModelText, _unref(email)]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "password",
                  class: "label"
                }, "Password", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    name: "password",
                    type: showPassword.value ? 'text' : 'password',
                    autocomplete: "current-password",
                    required: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                    class: "input pr-10",
                    placeholder: "••••••••"
                  }, null, 8, _hoisted_14), [
                    [_vModelDynamic, _unref(password)]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors",
                    title: showPassword.value ? 'Hide password' : 'Show password'
                  }, [
                    (showPassword.value)
                      ? (_openBlock(), _createBlock(_unref(EyeOff), {
                          key: 0,
                          class: "h-4 w-4"
                        }))
                      : (_openBlock(), _createBlock(_unref(Eye), {
                          key: 1,
                          class: "h-4 w-4"
                        }))
                  ], 8, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    id: "remember-me",
                    name: "remember-me",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rememberMe).value = $event)),
                    class: "h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded cursor-pointer"
                  }, null, 512), [
                    [_vModelCheckbox, rememberMe.value]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    for: "remember-me",
                    class: "ml-2 block text-xs text-gray-600 dark:text-gray-400 cursor-pointer"
                  }, " Remember me ", -1))
                ]),
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  class: "text-xs font-semibold text-secondary hover:text-secondary-hover dark:text-secondary-dark-text hover:underline"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Forgot password? ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _unref(loading),
                  class: "btn btn-primary w-full py-2.5 font-bold"
                }, [
                  (_unref(loading))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_unref(loading) ? 'Signing in...' : 'Sign in'), 1)
                ], 8, _hoisted_19)
              ])
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", _hoisted_22, [
            _cache[14] || (_cache[14] = _createTextVNode(" Looking for employment? ", -1)),
            _createVNode(_component_router_link, {
              to: "/apply",
              class: "font-semibold text-secondary hover:text-secondary-hover dark:text-secondary-dark-text hover:underline ml-1"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Submit an application ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})